import { useSwipable } from "client/hooks/utils/useSwipable";
import { ColorChip } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Color/ColorList/ColorList";
import { useColorPickerButton } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Color/ColorList/ColorPickerButton/useColorPickerButton";
import { Mode } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Color/types";
import { useRef } from "react";
import { defaultColors } from "store/features/memeGenerator/data/defaultColors";
import { TextBox } from "store/features/memeGenerator/types";
import { ColorPickerButton } from "./ColorPickerButton/ColorPickerButton";

interface ColorListProps {
    textBox: TextBox;
    mode: Mode;
}

export const ColorList = ({ textBox, mode }: ColorListProps) => {
    const { handleColorChange } = useColorPickerButton(textBox, mode);
    const swipeableRef = useRef<HTMLDivElement>(null);
    useSwipable(swipeableRef);
    return (
        <div className="flex items-center gap-2 w-full overflow-x-scroll" ref={swipeableRef}>
            <ColorPickerButton textBox={textBox} mode={mode} />
            {defaultColors.map((color) => (
                <ColorChip key={color} textBox={textBox} mode={mode} color={color} onColorChoose={handleColorChange} />
            ))}
        </div>
    );
};
